<section class="data-source-zero-state" *ngIf="(isLoaded | async) && (hasErrorState || getZeroStateStatus())">
	<ng-container *ngIf="hasErrorState" [ngSwitch]="errorCode">
		<ngx-zero-state *ngSwitchCase="0" class="error-connection">
			<div zero-state-title translate="folder-error-zero-states_internet-connection-lost-title"></div>
			<div zero-state-subtext translate="folder-error-zero-states_internet-connection-lost-subtext"></div>
			<div zero-state-graphic-bottom>
				<img class="zero-state-image" src="https://staticassets.goreact.com/floating-astronaut.svg" alt="internet connection error">
			</div>
		</ngx-zero-state>

		<ngx-zero-state *ngSwitchCase="404" class="error-not-found">
			<div zero-state-title translate="folder-error-zero-states_folder-not-found-title"></div>
			<div zero-state-subtext translate="folder-error-zero-states_folder-not-found-subtext"></div>
			<div zero-state-graphic-bottom>
				<img class="zero-state-image" src="https://staticassets.goreact.com/floating-astronaut.svg" alt="not found">
			</div>
		</ngx-zero-state>

		<ngx-zero-state *ngSwitchCase="403" class="error-forbidden">
			<div zero-state-title translate="folder-error-zero-states_folder-not-found-title"></div>
			<div zero-state-subtext translate="folder-error-zero-states_folder-forbidden-subtext"></div>
			<div zero-state-graphic-bottom>
				<img class="zero-state-image" src="https://staticassets.goreact.com/floating-astronaut.svg" alt="forbidden">
			</div>
		</ngx-zero-state>

		<!--Unexpected Error-->
		<ngx-zero-state *ngSwitchDefault class="error-unexpected">
			<div zero-state-title translate="folder-error-zero-states_unexpected-title"></div>
			<div zero-state-subtext translate="folder-error-zero-states_unexpected-subtext"></div>
			<div zero-state-graphic-bottom>
				<img class="zero-state-image" src="https://staticassets.goreact.com/floating-astronaut.svg" alt="unexpected error">
			</div>
		</ngx-zero-state>
	</ng-container>

	<ng-container *ngIf="!hasErrorState" [ngSwitch]="getZeroStateStatus()">
		<ngx-zero-state
			*ngSwitchCase="zeroStates.DEACTIVATED_ROLE"
			class="zero-state-deactivated-role">
			<div zero-state-title translate="group-view_zero-state-blocked-from-course-title"></div>
			<div zero-state-subtext translate="group-view_zero-state-blocked-from-course-subtext"></div>
			<div zero-state-body>
				<a href="https://help.goreact.com/hc/en-us/articles/115001588966" target="_blank" rel="noopener noreferrer" class="primary-btn manage-btn" translate="group-view_zero-state-blocked-from-course-link"></a>
			</div>
			<div zero-state-graphic-bottom>
				<img class="zero-state-image" src="https://staticassets.goreact.com/floating-astronaut.svg" alt="Deactivated Role">
			</div>
		</ngx-zero-state>

		<ngx-zero-state
			class="zero-state-maximum-seats-reached"
			*ngSwitchCase="zeroStates.MAX_SEAT_REACHED">
			<div zero-state-title translate="group-view_zero-state-maximum-seats-reached-title"></div>
			<div zero-state-subtext translate="group-view_zero-state-maximum-seats-reached-subtext"></div>
			<div zero-state-graphic-bottom>
				<img class="zero-state-image" src="https://staticassets.goreact.com/floating-astronaut.svg" alt="Max Seats Reached">
			</div>
		</ngx-zero-state>

		<ngx-zero-state
			class="zero-state-no-eligible-billing"
			*ngSwitchCase="zeroStates.NO_ELIGIBLE_BILLING">
			<div zero-state-title><span>{{ group.name }}</span></div>
			<div zero-state-subtext>
				<ng-container *ngIf="group.hasInstructorRole(true)">
					<span translate="group-view_zero-state-no-eligible-billing-subtext-instructor"></span>
				</ng-container>

				<ng-container *ngIf="!group.hasInstructorRole(true)">
					<span translate="group-view_zero-state-no-eligible-billing-subtext-student"></span>
				</ng-container>
			</div>
			<div zero-state-body>
				<button
					*ngIf="group.hasInstructorRole(true)"
					class="btn primary-btn manage-btn eligible-btn"
					translate="manage-folder_button-title"
					(click)="openGroupSettings()">
				</button>
			</div>
			<div zero-state-graphic-bottom>
				<img class="zero-state-image" class="zero-state-image" src="https://staticassets.goreact.com/floating-astronaut.svg" alt="No longer on a license">
			</div>
		</ngx-zero-state>

		<course-payment-wall
			*ngSwitchCase="zeroStates.COURSE_PAYMENT_WALL"
			[course]="group"
			[user]="user"
			(onCredit)="onCredit()"
			(onPay)="onPay($event)"
		>
		</course-payment-wall>
	</ng-container>
</section>

<section class="data-source-zero-state loading" *ngIf="(isLoaded | async) !== true">
	<loading></loading>
</section>
